var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Documents & Safety/lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66675 7.5V5.83333C6.66675 3.99238 8.15913 2.5 10.0001 2.5C11.841 2.5 13.3334 3.99238 13.3334 5.83333V7.5M6.83341 17.5H13.1667C14.1002 17.5 14.5669 17.5 14.9234 17.3183C15.237 17.1586 15.492 16.9036 15.6518 16.59C15.8334 16.2335 15.8334 15.7668 15.8334 14.8333V10.1667C15.8334 9.23325 15.8334 8.76654 15.6518 8.41002C15.492 8.09641 15.237 7.84144 14.9234 7.68166C14.5669 7.5 14.1002 7.5 13.1667 7.5H6.83341C5.89999 7.5 5.43328 7.5 5.07676 7.68166C4.76316 7.84144 4.50819 8.09641 4.3484 8.41002C4.16675 8.76654 4.16675 9.23325 4.16675 10.1667V14.8333C4.16675 15.7668 4.16675 16.2335 4.3484 16.59C4.50819 16.9036 4.76316 17.1586 5.07676 17.3183C5.43328 17.5 5.89999 17.5 6.83341 17.5Z",
    stroke: "#9599A1",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3a56333b79d7b7aa0663065985b6fef9.svg";
export { ForwardRef as ReactComponent };